import {
  reactive, inject,
} from 'vue';

// Crie um objeto reativo para armazenar seu barramento de eventos
const EventBusSymbol = Symbol('event-bus');
const eventBus = reactive({});

// Função para emitir eventos
function emitEvent(eventName, payload) {
  if (Array.isArray(eventBus[eventName])) {
    eventBus[eventName].forEach((callback) => {
      if (typeof callback === 'function') {
        callback(payload);
      } else {
        console.error('Callback is not a function:', callback);
      }
    });
  } else {
    console.error('Event name not found or does not contain an array of callbacks:', eventName);
  }
}

// Função para ouvir eventos
function onEvent(eventName, callback) {
  if (!eventBus[eventName]) {
    eventBus[eventName] = [];
  }
  eventBus[eventName].push(callback);
}

// Função para parar de ouvir eventos
function offEvent(eventName, callback) {
  if (eventBus[eventName]) {
    eventBus[eventName] = eventBus[eventName].filter((cb) => cb !== callback);
  }
}

// Provê o barramento de eventos para ser utilizado globalmente
function provideEventBus(app) {
  app.provide(EventBusSymbol, {
    emitEvent,
    onEvent,
    offEvent,
  });
}

// Função para injetar o barramento de eventos nos componentes
function useEventBus() {
  const eventBus = inject(EventBusSymbol);
  if (!eventBus) {
    throw new Error('Event Bus not provided!');
  }
  return eventBus;
}

export { provideEventBus, useEventBus };
